import axios from 'axios';

export default {
  state: {
  },
  actions: {
    async changePassword({ commit }, params) {
    let result = null;
    commit
      await axios
        .post(`/api/account/changepassword`, params)
        .then((response) => {
            result = response.data;
        })
        .catch((error) => {
          throw error;
        });
        return result;
    }
  },
  mutations: {
    // deleteNotifsByChat(s, chat) {
    //   s.user_notifications.messages.rows = s.user_notifications.messages.rows.filter(
    //     (message) => message.chat !== chat.id
    //   );
    // }
  },
  getters: {
    // getAuthUser: (s) => s.userAuth,
  },
};
